module.exports = __webpack_public_path__ + "static/media/20.14d1a28a.jpg";